import { Delete, Save } from "assets/icons/Common";
import { ReactNode } from "react";
import styled from "styled-components";

const ModalSaveHeaderStyled = styled("div")`
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 16pt;

  svg {
    color: var(--primary);
    max-width: 30px;
    margin-right: 20px;
  }
`;

export const ModalSaveHeader: ReactNode = (
  <ModalSaveHeaderStyled>
    <Save />
    Save Word List
  </ModalSaveHeaderStyled>
);

export const ModalDeleteHeader: ReactNode = (
  <ModalSaveHeaderStyled>
    <Delete />
    Delete List
  </ModalSaveHeaderStyled>
);
